import { createApi } from '@reduxjs/toolkit/query/react'
import { baseUrl } from './axiosInstance'
import axiosBaseQuery from './axiosBaseQuery'

const thresholdsApi = createApi({
  baseQuery: axiosBaseQuery({
    baseUrl
  }),
  reducerPath: 'thresholdsApi',
  tagTypes: ['thresholdsApi'],
  endpoints: () => ({})
})

export default thresholdsApi
